import React, { useRef, useState } from 'react';
import Files from 'react-files';
import { useNavigate } from "react-router-dom";
import { uploadFileService } from "../service";
import "../pages/UploadFile.css";
import { Box, Button } from "@mui/material";
import LinearProgress from "@mui/material/LinearProgress";

const DragAndDrop = ({ phonenumber }) => {
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [fileUploadinProgress, setFileUploadInProgress] = useState(false);
    const [fileUploadFailed, setFileUploadFailed] = useState(false);
    const navigate = useNavigate();
    const filename = useRef();
    const data = new FormData();

    const onFilesChange = async (files) => {
        data.append("file_upload_location", files[files.length-1]);
        data.append("customer_phone_number", phonenumber);
        data.append("document_description", files[files.length-1].name);
        data.append("image_type", 0);

        try {
            var response = await uploadFileService(data);

            const val = await response.json();
            if (val?.id) {
                setUploadedFiles((oldArray) => [
                    ...oldArray,
                    files[files.length-1].name,
                ]);
            } else {
                setFileUploadFailed(true);
            }
        } catch (ex) {
            setFileUploadFailed(true);
            console.log("Error", ex);
        } finally {
            setFileUploadInProgress(false);
        }
    };

    const uploadFile = (e) => {
        e.preventDefault()
        onFilesChange(filename.current.files)
    };

    const onFilesError = (error, file) => {
        console.log('error code ' + error.code + ': ' + error.message)
    }

    return (
        <div className="w-100">
            <div className="mb-3 w-100 align-center-content" style={{ backgroundColor: "#ffc464", color: '#FFFFFF', }}>
                <div className="dotted-content " >
                    <div className="w-100">
                        <div className="files">
                            <Files
                                className='files-dropzone dragdrop-content'
                                onChange={onFilesChange}
                                onError={onFilesError}
                                accepts={['image/png', 'image/jpeg', 'image/gif', '.pdf']}
                                // multiple
                                maxFiles={3}
                                maxFileSize={10000000}
                                minFileSize={0}
                                clickable
                            >
                                <h2 className="text-center center-item">UPLOAD YOUR FILES</h2>
                            </Files>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mb-2">
                <div className="center-item">
                    <h6 className="headerStyle">Accepted Files: pdf, jpeg, jpg, png, and gif</h6>
                </div>
                <div className="center-item">
                    <Button
                        // variant="contained"
                        component="label"
                        style={{ backgroundColor: "#ffc464", color: '#FFFFFF' }}
                    >
                        SELECT FILE TO UPLOAD
                        <input
                            type="file"
                            accept="image/png, image/jpeg, image/gif, .pdf"
                            hidden
                            onChange={uploadFile}
                            ref={filename}
                        />
                    </Button>
                </div>
                <div className="header_box">
                    <h6 className="headerStyle">OR DRAG AND DROP</h6>
                </div>
                {fileUploadinProgress && (
                    <Box sx={{ width: "100%" }}>
                        <LinearProgress />
                    </Box>
                )}
                {fileUploadFailed && (
                    <div className="text-danger" style={{textAlign:"center"}}>File upload failed.</div>
                )}
                {uploadedFiles.map((file) => {
                    return (
                        <div class="container" key={uploadedFiles.indexOf(file)}>
                            <div class="row list-items">
                                File uploaded - {file}
                            </div>
                        </div>
                    );
                })}
                {uploadedFiles.length > 0 && (
                    <div className="mt-2 center-item">
                        <Button
                            component="label"
                            style={{ backgroundColor: "#ffc464", color: '#FFFFFF' }}
                            onClick={() => navigate(`/`)}
                        >
                            Done
                        </Button>
                    </div>
                )}
            </div>
        </div>

    )
}
export default DragAndDrop